import _ from 'lodash';

export default (items) => ({
    items: items,

    addItem() {
        this.items.push({
            name: '',
            quantity: '',
            minimum: '',
        });
    },

    removeItem(index) {
        this.items.splice(index, 1);
    },

    getMessage(errors, propertyName, index, field) {
        return _.get(errors, propertyName+'.'+index+'.'+field);
    },
});
